import { getApiOrigin } from "@/shared/libs/axios/base-url";

/**
 * 저장소 상대 경로(`resources/uploads/...`)를 브라우저에서 열 수 있는 URL 로 변환한다.
 * 로컬 저장소는 API 서버가 `/resources/` 로 정적 서빙한다. 이미 절대 URL 이면 그대로 반환.
 */
export const toImageUrl = (path: string) =>
  /^https?:\/\//.test(path) ? path : `${getApiOrigin()}/${path.replace(/^\/+/, "")}`;
